<div  class="alert alert-danger animated fadeIn">
    <h3>{{msjError}}</h3>
    <p>
        <!-- {{msjError}} -->
    </p>
</div>

